import * as React from "react";
import { useParams } from "react-router";

import { ErrorAlert } from "@/components/ui/errorAlert";
import { Loader } from "@/components/ui/loader";
import { getSnapshotGridCapabilities } from "@/modules/snapshots/grid/dataSource";
import { SnapshotGridCore } from "@/modules/snapshots/grid/SnapshotGridCore";
import { useGetSnapshotViewQuery } from "@/modules/snapshots/snapshotViews.api";

export const SnapshotViewGrid: React.FC = () => {
  const { viewId = "" } = useParams<{ viewId: string }>();
  const viewQuery = useGetSnapshotViewQuery(viewId);

  if (viewQuery.isLoading) return <Loader />;
  if (viewQuery.error || !viewQuery.data || !viewQuery.data.template_id) {
    return <ErrorAlert title="Unable to open view" error={viewQuery.error} />;
  }

  return (
    <SnapshotGridCore
      key={`${viewQuery.data.id}:${JSON.stringify(viewQuery.data.configuration)}`}
      snapshotCollectionId={viewQuery.data.snapshot_collection_id}
      templateId={viewQuery.data.template_id}
      mode="view"
      capabilities={{ ...getSnapshotGridCapabilities("view"), sharing: false }}
      snapshotView={viewQuery.data}
      initialConfiguration={viewQuery.data.configuration}
    />
  );
};
